<script>
  import { transactionStore } from '../../stores'
  import { config } from '../../../scripts/defaultURL'
  import { formatDate } from '../../../scripts/functions'
  import { deleteData } from '../../../scripts/rest'

  export let transaction
  $: console.table(transaction)

  function closeModal() {
    document.getElementById('deleteTransactionModal')?.classList.remove('is-active')
    document.getElementById('editTransactionModal')?.classList.remove('is-active')

    transactionStore.update((store) => {
      const current = store || {}
      current['todo'] = 'getData'
      return current
    })
  }

  function deleteTransaction() {
    deleteData(`${config.defaultURL}/transactions/delete/${transaction.id}`)
      .catch((error) => console.error('Failed to delete transaction:', error))
      .then((res) => {
        if (res) console.log(res)
        closeModal()
      })
  }
</script>

<div class="modal" id="deleteTransactionModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Are you sure you want to delete this transaction?
      </p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <form on:submit|preventDefault={deleteTransaction}>
        <div class="field">
          <b>Date:</b>
          {formatDate(transaction.date)}<br />
          <b>Amount:</b> ${transaction.amount}<br />
          <b>Description:</b>
          {transaction.description}<br />
          {#if transaction.category}
            <b>Category:</b> {transaction.category}
          {/if}
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button class="button is-danger" type="submit"
              >Yes, Delete Transaction</button
            >
          </div>
          <div class="control">
            <button
              type="reset"
              on:click={closeModal}
              class="button is-primary is-light">Cancel</button
            >
          </div>
        </div>
      </form>
    </section>
  </div>
</div>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>
